export namespace NotificationGroupId {
  export const Inbox = 1n;
  export const Copy = 2n;
  export const Comissions = 3n;
}

export type NotificationGroupIdType =
  (typeof NotificationGroupId)[keyof typeof NotificationGroupId];
